import React, {Fragment} from 'react';
import { translate } from '../Services/translation';

const MiniCart = ({ quantity, orderTotal, checkoutUrl, showInfo, toggle, orderRows, removeOrderRow, updateOrderRowQuantity }) => {
    const productHeaderClass  = "columns small-12 medium-4 large-6"; /* = productContentClass */
    const priceHeaderClass    = "columns small-3 medium-2 large-2"; /* = priceContentClass */
    const quantityHeaderClass = "columns small-4 medium-3 large-2"; /* = quantityInputClass + quantityActionClass  */
    const totalHeaderClass    = "columns small-5 medium-3 large-2"; /* = totalContentClass + totalActionClass  */
    const productContentClass = "columns small-12 medium-4 large-6" + " checkout-cart__image-container";
    const priceContentClass   = "columns small-3 medium-2 large-2" + " simple-table__cell--no-break-word";
    const quantityInputClass  = "columns small-2 medium-2 large-1";
    const quantityActionClass = "columns small-2 medium-1 large-1";
    const totalContentClass   = "columns small-2 medium-1 large-1" + " simple-table__cell--no-break-word";
    const totalActionClass    =  "columns small-3 medium-2 large-1";
    if (orderRows && orderRows.length > 0) {
        console.log(orderRows[0]);
    }

    return (
        <div className={"cart " + (quantity === "0" ? "cart--mini-empty" : "cart--mini") }>
            <a className="cart__link--block" onClick={() => toggle()}>
                <i className="cart__icon">
                    <span className={quantity === "0" ? "cart__quantity-empty" : "cart__quantity"}>{quantity}</span>
                </i>
                <span className="cart__title">{translate('minicart.show')}</span>
            </a>
            <div className={`cart__info ${!showInfo ? 'cart__info--hidden' : ''}`}>
            <span className="cart__close-button" onClick={() => toggle()}>
            </span>
                <p className="cart__info-row">{quantity} {translate('minicart.quantity')}</p>
                {orderRows && orderRows.slice(0, 3).map(order => (
                    <div className="row small-unstack no-margin checkout-cart__row" key={order.rowSystemId}>
                        <div className={"columns small-12 medium-2 checkout-cart__image-wrapper cart--mini__image-wrapper"}>
                            <img className="checkout-cart__image cart--mini__image" src={order.image} alt={order.name}/>
                        </div>
                        <div className={"columns small-12 medium-10"}>
                            <div>
                                <a href={order.url}>{order.name}</a>
                                <span className="checkout-cart__brand-name">{order.brand}</span>
                            </div>
                            <div className="pricex">
                                {//translate('checkout.cart.header.price')}:
                                }
                                {order.campaignPrice ? (
                                    <Fragment>
                                        <span className='checkout-cart__campaign-price'>{order.campaignPrice}</span>
                                        <span className='checkout-cart__original-price'> ({order.price})</span>
                                    </Fragment>
                                ) : order.price}{' '}
                                {' (x'} {order.quantity}{') '}
                                {//translate('checkout.cart.header.total')} {order.totalPrice
                                }
                                <Fragment>
                                    <a className="table__icon table__icon--delete" onClick={() => removeOrderRow(order.rowSystemId)} title={translate('general.remove')}></a>
                                </Fragment>
                            </div>
                            <hr/>
                        </div>
                    </div>
                ))}
                <p className="cart__info-row"><b>{translate('minicart.total')}</b> {orderTotal}</p>
                <a href={checkoutUrl} className="cart__checkout-button">{translate('minicart.toCheckout')}</a>
            </div>
        </div>
    )
}

export default MiniCart;